/** Shared client/server shapes for the Json columns of Playbook. */
export type PlaybookSession = {
  name: string;
  startTime: string;
  endTime: string;
  timezone: string;
};

export type PlaybookSetup = {
  name: string;
  entryRules: string;
  exitRules: string;
};

export type PlaybookRisk = {
  type: "percent" | "amount";
  value: number;
};

export type PlaybookPropFirmOverrides = {
  maxDailyDrawdown?: number | null;
  maxTotalDrawdown?: number | null;
  profitTarget?: number | null;
  unit?: "percent" | "amount" | null;
};

/** Instruments offered as quick picks. Traders can still type anything else. */
export const COMMON_MARKETS = [
  "NQ",
  "MNQ",
  "ES",
  "MES",
  "YM",
  "MYM",
  "RTY",
  "M2K",
  "GC",
  "MGC",
  "CL",
  "MCL",
  "SI",
  "NG",
  "ZB",
  "ZN",
  "6E",
  "6B",
  "EURUSD",
  "GBPUSD",
  "USDJPY",
  "AUDUSD",
  "USDCAD",
  "XAUUSD",
  "BTC",
  "ETH",
] as const;

/**
 * Session presets in exchange-local time. `labelKey` maps to the i18n keys so the
 * preset names stay translated; the trader can rename and retime them afterwards.
 */
export const SESSION_PRESETS: Array<{
  labelKey: "presetAsia" | "presetLondon" | "presetNewYork";
  session: PlaybookSession;
}> = [
  {
    labelKey: "presetAsia",
    session: { name: "Asia", startTime: "00:00", endTime: "08:00", timezone: "Asia/Tokyo" },
  },
  {
    labelKey: "presetLondon",
    session: { name: "London", startTime: "08:00", endTime: "16:30", timezone: "Europe/London" },
  },
  {
    labelKey: "presetNewYork",
    session: { name: "New York", startTime: "09:30", endTime: "16:00", timezone: "America/New_York" },
  },
];

export const PLAYBOOK_STEP_COUNT = 3;
